const camelcaseKeysDeep = require('camelcase-keys-deep');

export class History {
  key: string;
  name: string;
  active: boolean;
  description: string;

  constructor(data: any) {
    data = camelcaseKeysDeep(data);

    if (data && typeof data === 'string') {
      this.key = data;
      this.active = true;
      this.name = data;
    } else {
      this.key = data.key;
      this.name = data.name;
      this.active = data.active;
      this.description = data.description;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/histories/history.ts